import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Grid } from "@mui/material";
import instagramIcon from "../../assets/instagram.png";
import fbIcon from "../../assets/fb-icon.png";
import logo from "../../assets/kazhavda-logo-white.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <Grid
          container
          direction={{ xs: "column", sm: "row" }}
          justifyContent={{ xs: "center", sm: "space-between" }}
          alignItems={{ xs: "center", sm: "flex-start" }}
          sx={{
            px: { xs: 2, sm: "10%" },
            gap: { xs: 2, sm: 0 }, // optional spacing between items
          }}
        >
          <Grid item>
            <img src={logo} alt="Kazhav Da Logo" className="footer-logo" />
          </Grid>
          <Grid item className="footer-social-icons">
            <a
              href="https://www.instagram.com/kazhavda.mk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61571710476340"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fbIcon} alt="Facebook" />
            </a>
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="space-evenly"
          alignItems="flex-start"
          className="footer-info"
        >
          <Grid
            item
            size={{ xs: 12, sm: 2 }}
            //xs={12} sm={2}
          >
            <h5 className="footer-header">КОРИСНИ ЛИНКОВИ</h5>
            <ul>
              <li>
                <Link to="/login" className="footer-nav-link">
                  Најави се
                </Link>
              </li>
              <li>
                <Link to="/venues" className="footer-nav-link">
                  Продавници
                </Link>
              </li>
              <li>
                <Link to="/all-products" className="footer-nav-link">
                  Продукти
                </Link>
              </li>
              {/* <li>
                <Link to="/pricing" className="footer-nav-link">
                  Ценовник
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="footer-nav-link">
                  Контакт
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="footer-nav-link">
                  Услови и одредби
                </Link>
              </li>
            </ul>
          </Grid>

          <Grid size={{ xs: 12, sm: 2 }}>
            <h5 className="footer-header">ПЛАНЕР ЗА СВАДБА</h5>
            <p>
              Испланирајте ја вашата свадба со леснотија и едноставно користејќи
              ја нашата апликација.
            </p>
          </Grid>

          <Grid item size={{ xs: 12, sm: 2 }}>
            <h5 className="footer-header">ЗАШТЕДА НА ВРЕМЕ</h5>
            <p>
              Нашиот продукт им помага на луѓето да сочуваат време при планирање
              свадба.
            </p>
          </Grid>

          <Grid item size={{ xs: 12, sm: 2 }}>
            <h5 className="footer-header">ПОПУЛАРНО</h5>
            <ul>
              <li>
                <Link
                  to="/venue/b66bc4a1-58d9-4f53-9d31-c43948e685e0"
                  className="footer-nav-link"
                >
                  Фора.мк
                </Link>
              </li>
              <li>
                <Link
                  to="/venue/f91456e1-15ae-425e-906b-9fa0d0a1fd4a"
                  className="footer-nav-link"
                >
                  La Mia Catering
                </Link>
              </li>
              <li>
                <Link
                  to="/venue/7b347791-c4fc-4c21-bcd6-491c8f464819"
                  className="footer-nav-link"
                >
                  Happy End Band
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
      </div>
    </footer>
  );
}

export default Footer;
